module.exports = __webpack_public_path__ + "img/google-play-it-black.c452866d.png";